import styled from 'styled-components';
import { BoxShadowLarge, ColorNordicGrey1, ColorNordicGrey5 } from 'autogen/design-tokens/tokens';
import DrawerView from 'components/generic/Drawer/DrawerView';
import { backgroundStripes } from 'modules/helpers/style';

export const MenuStripes = styled.div`
    display: flex;
    min-height: 16px;
    width: 100%;
    ${backgroundStripes({ color1: ColorNordicGrey1, color2: ColorNordicGrey5 })};
    position: absolute;
    bottom: 0;
`;

export const StyledDrawerView = styled(DrawerView)`
    box-shadow: ${BoxShadowLarge};
    flex-direction: column;
`;
